import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BackEndService } from 'src/app/services/backEnd.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {

  @Output() newData = new EventEmitter<void>();

  constructor(public backEnd: BackEndService) { }

  ngOnInit() { }

}
